module.exports = {
  companies: 'कंपनियों',
  catalogs: 'कैटलॉग',
  accounts: 'हिसाब किताब',
  printers: 'प्रिंटर',
  login: 'लॉग इन करें',
  logout: 'लोग आउट',
};



// WEBPACK FOOTER //
// ./src/lang/hi/header.js